module.exports = __webpack_public_path__ + "static/media/crowd-cheers.28de2c19.mp3";